import { useRef } from "react";

import ContactsModal from "../../components/ContactsModal/ContactsModal";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import MainPageHero from "./MainPageHero";
import MainPageInfo from "./MainPageInfo";
import MainPageVpns from "./MainPageVpns";

function MainPage() {
  const infoRef = useRef<HTMLElement | null>(null);

  const scrollToInfo = () => {
    infoRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="bg-main">
      <Header enableSearch={false} />
      <MainPageHero onScrollToInfo={scrollToInfo} />
      <MainPageVpns />
      <MainPageInfo ref={infoRef} />
      <Footer />
      <ContactsModal />
    </div>
  );
}

export default MainPage;
